import type { KiEreignis, KiGespraech } from '@beholder/shared/module/ki';
import { ApiFehler, modulPfad } from '../../core/api';

export type FragenEreignis = KiEreignis | { typ: 'gespraech'; gespraech: KiGespraech };

/** Stellt eine Frage; die Antwort kommt als Strom aus JSON-Zeilen (Status, Schritte, fertig). */
export async function fragenStrom(
  projektId: string,
  gespraechId: string | null,
  text: string,
  bei: (e: FragenEreignis) => void,
): Promise<void> {
  const r = await fetch(modulPfad(projektId, 'ki', 'fragen'), {
    method: 'POST',
    credentials: 'same-origin',
    headers: { 'x-beholder': '1', 'content-type': 'application/json' },
    body: JSON.stringify({ gespraechId, text }),
  });
  if (!r.ok || !r.body) {
    const j = (await r.json().catch(() => null)) as { fehler?: string } | null;
    if (r.status === 401) window.dispatchEvent(new CustomEvent('beholder:abgemeldet'));
    throw new ApiFehler(r.status, j?.fehler ?? `Fehler ${r.status}`);
  }
  const leser = r.body.getReader();
  const dekoder = new TextDecoder();
  let rest = '';
  for (;;) {
    const { done, value } = await leser.read();
    if (value) rest += dekoder.decode(value, { stream: true });
    let i: number;
    while ((i = rest.indexOf('\n')) >= 0) {
      const zeile = rest.slice(0, i).trim();
      rest = rest.slice(i + 1);
      if (zeile) {
        try {
          bei(JSON.parse(zeile) as FragenEreignis);
        } catch {
          /* unvollständige Zeile ignorieren */
        }
      }
    }
    if (done) break;
  }
}

/** Öffnet den Chat (z. B. von der Seite „KI-Hilfe“ aus) mit einem bestimmten Gespräch. */
export function chatOeffnen(gespraechId: string | null) {
  window.dispatchEvent(new CustomEvent('beholder:ki-oeffnen', { detail: { gespraechId } }));
}

export const ANBIETER_NAME: Record<string, string> = { lokal: 'Lokale KI', claude: 'Claude', 'lokal (SearXNG)': 'Lokal (SearXNG)' };
